import React from "react";
import Table from "../../../../utils/components/Table";
import Spinner from "../../../../utils/components/Spinner";

const StandingsTable = ({ standings, loading }) => {
  const groupNames = Object.keys(standings || {});

  const headers = [
    { label: "#", ref: "position", className: "text-center" },
    { label: "Equipo", ref: "teamDisplay", className: "" },
    { label: "PJ", ref: "playedGames", className: "text-center" },
    { label: "PG", ref: "matchesWon", className: "text-center" },
    { label: "PE", ref: "matchesTied", className: "text-center" },
    { label: "PP", ref: "matchesLost", className: "text-center" },
    { label: "GF", ref: "goalsMade", className: "text-center" },
    { label: "GC", ref: "goalsReceived", className: "text-center" },
    { label: "DG", ref: "goalDifference", className: "text-center" },
    { label: "Pts", ref: "points", className: "text-center" },
    { label: "Efect.", ref: "effectiveness", className: "text-center" },
  ];

  const buildRows = (teams) =>
    teams.map((entry, index) => ({
      ...entry,
      position: index + 1,
      teamDisplay: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {entry.team && entry.team.image && entry.team.image.team_small ? (
            <img
              src={entry.team.image.team_small}
              alt={entry.team.shortName || entry.team.name}
              style={{ width: 24, height: 24, borderRadius: "50%", objectFit: "cover" }}
            />
          ) : null}
          <span>{entry.team ? (entry.team.shortName || entry.team.name) : "—"}</span>
        </div>
      ),
      backgroundColor: entry.color || undefined,
    }));

  if (loading) {
    return (
      <div className="panel panel-default">
        <div className="panel-heading">Tablas de Posiciones</div>
        <div className="panel-body">
          <Spinner show={true} />
        </div>
      </div>
    );
  }

  if (!groupNames.length) {
    return (
      <div className="panel panel-default">
        <div className="panel-heading">Tablas de Posiciones</div>
        <div className="panel-body">
          <p className="text-center">No se encontraron posiciones para este torneo.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {groupNames.map((groupName) => (
        <div className="panel panel-default" key={groupName}>
          <div className="panel-heading">
            Grupo {groupName}
          </div>
          <div className="panel-body">
            <Table
              headers={headers}
              rows={buildRows(standings[groupName])}
              notFoundMessage="No hay equipos en este grupo."
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default StandingsTable;
